<template>
  <div
    v-if="user"
    class="user"
  >
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('label.showUser') }}
        </h3>
        <div class="pull-right box-tools">
          <a
            class="btn btn-default btn-sm"
            @click="$router.back()"
          >
            <i class="fa fa-arrow-circle-left" /> {{ $t('button.back') }}
          </a>
        </div>
      </div>
      <div class="box-body">
        <ul
          class="nav nav-tabs"
          role="tablist"
        >
          <li
            class="active"
            role="presentation"
          >
            <a
              aria-controls="profile"
              data-toggle="tab"
              href="#profile"
              role="tab"
            >
              <i class="fa fa-user" /> {{ $t('label.profile') }}
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div
            id="profile"
            class="tab-pane active"
            role="tabpanel"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{{ $t('label.avatar') }}</td>
                        <td>
                          <XImage
                            :src="user.avatar"
                            alt="User Avatar"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.firstName') }}</td>
                        <td>: {{ user.first_name }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.lastName') }}</td>
                        <td>: {{ user.last_name }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.gender') }}</td>
                        <td>: {{ user.gender && user.gender.name_en ? user.gender.name_en : $t('string.na') }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.updatedAt') }}</td>
                        <td>: {{ user.updated_at || $t('string.na') }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.role') }}</td>
                        <td>
                          <ul v-if="user.roles && Array.isArray(user.roles) && user.roles.length >0">
                            <li
                              v-for="(role, key) in user.roles"
                              :key="key"
                            >
                              {{ role['display_name_' + $i18n.locale] || role.name }}
                            </li>
                          </ul>
                          <template v-else>
                            {{ $t('string.na') }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.additionalPermissions') }}</td>
                        <td>
                          <ul v-if="user.permissions && Array.isArray(user.permissions) && user.permissions.length >0">
                            <li
                              v-for="(permission, key) in user.permissions"
                              :key="key"
                            >
                              {{ permission['display_name_' + $i18n.locale] || role.name }}
                            </li>
                          </ul>
                          <template v-else>
                            {{ $t('string.na') }}
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XImage from '@/components/XImage'
export default {
  name: 'Show',
  components: { XImage },
  metaInfo () {
    return {
      title: this.$t('label.showUser'),
      titleTemplate: '%s | ' + this.$t('string.appName')
    }
  },
  data () {
    return {
      user: {
        first_name: null,
        last_name: null,
        gender: null,
        updated_at: null,
        roles: [],
        permissions: []
      }
    }
  },
  mounted () {
    this.fetchUserByUuid()
  },
  methods: {
    fetchUserByUuid () {
      this.$axios.post(process.env.VUE_APP_API + '/api/backend/user/get-user-by-uuid', {
        uuid: this.$route.params.uuid
      }).then(({ data }) => {
        if (data.data) {
          this.user = data.data
        }
      }).catch(error => {
        this.onResponseError(error)
      })
    }
  }
}
</script>

<style scoped>

</style>
